import { createFileRoute } from '@tanstack/react-router'
import ExceptionsSettings from '@/pages/settings/exceptions'
import { paginationSearchSchema } from '@/lib/pagination'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/exceptions'
)({
  validateSearch: paginationSearchSchema,
  component: ExceptionsSettings,
})
